//import React, { useEffect } from 'react';
import '../styles/global_styles.css';
import Header from '../components/Header';
import CotizadorPasoAPaso from '../components/CotizadorPasoAPaso';
import cotizadorStore from '../store/cotizador';
import globalStore from '../store/global';

const Cotizador = () => {
    const steps = ['Cotizar', 'Integrantes', 'Validar', 'Pagar'];

    const { seccion, setSeccion } = globalStore();
    const { pasoActual, setPasoActual } = cotizadorStore();   

    const navegarA = (destino: string) => {
        setSeccion(destino);
        let seccionElement = document.getElementById(destino);
        if (seccionElement === null) return;
        seccionElement.scrollIntoView({ behavior: 'smooth' });
    };
              
    return (
        <>
            <Header navegacionFija={false} seccionActual={'cotizador'} cambiarSeccion={navegarA}></Header>
            <CotizadorPasoAPaso navegacionFija={false} id={'seleccionarPlan'} pasos={steps} paso={pasoActual} setpaso={setPasoActual}/>
        </>
    );
};

export default Cotizador;